import ApiService from "@/core/services/api.service";
import {PURGE_AUTH} from "./auth.module";
import JwtService from "@/core/services/jwt.service";

// action types
export const GET_HOME_PAGE = "getHomePageStore";
export const ADD_SLIDE = "addSlideStore";
export const SAVE_SLIDE = "saveSlideStore";
export const SLIDE_REQUEST = "slideRequestStore";
export const SAVE_ABOUT = "saveAboutStore";
export const SAVE_SERVICE = "saveServiceStore";
export const SAVE_BANNER = "saveBannerStore";
export const SAVE_META = "saveMetaStore";

// mutation types
export const SET_HOME_PAGE = "setHomePageStore";
export const SET_HOME_PAGE_ERROR = "setHomePageErrorStore";
export const SET_HOME_PAGE_LOAD = "setHomePageLoadStore";
export const SET_SLIDES = "setSlidesStore";
export const SET_SLIDES_ERROR = "setSlidesErrorStore";

const state = {
    home: {
        about: [],
        collection_banner: [],
        service: [],
        slides: [],
    },
    errors: {
        slide: {}
    },
    load: true,
};

const getters = {

    gettersHomePage(state) {
        return state.home;
    },

    getHomePageLoad(){
        return state.load;
    },

    errorsHomePage(){
        return state.errors;
    },
};

const actions = {

    [GET_HOME_PAGE](context) {
        context.commit(SET_HOME_PAGE_LOAD, true);
        return new Promise((resolve, reject) => {
            ApiService.get("/home")
                .then(({ data }) => {
                    resolve(data);
                    context.commit(SET_HOME_PAGE, data);
                    context.commit(SET_HOME_PAGE_LOAD, false);
                })
                .catch(({ response }) => {
                    reject(response);
                    context.commit(SET_HOME_PAGE_ERROR, response.data.errors);
                    context.commit(SET_HOME_PAGE_LOAD, false);
                });
        });
    },


    [ADD_SLIDE](context, data){
        return new Promise((resolve, reject) => {
            context.commit(SET_SLIDES_ERROR, {});
            ApiService.post("/slide-add", data)
                .then(({ data }) => {
                    resolve(data);
                    context.commit(SET_SLIDES, data.slides);
                    context.commit(SET_SLIDES_ERROR, {});
                })
                .catch(({ response }) => {
                    reject(response);
                    if (response.status === 422){
                        context.commit(SET_SLIDES_ERROR, response.data.errors);
                    }
                });
        });
    },

    [SLIDE_REQUEST](context, data){
        return new Promise((resolve, reject) => {
            context.commit(SET_SLIDES_ERROR, {});
            ApiService.post("/slide-request", data)
                .then(({ data }) => {
                    resolve(data);
                    context.commit(SET_SLIDES_ERROR, {});
                })
                .catch(({ response }) => {
                    reject(response);
                    if (response.status === 422){
                        context.commit(SET_SLIDES_ERROR, response.data.errors);
                    }
                });
        });
    },

    [SAVE_SLIDE](context, data) {
        if (JwtService.getToken()) {
            return new Promise((resolve, reject) => {
                ApiService.post("/slides-save", data)
                    .then(({ data }) => {
                        resolve(data);
                        context.commit(SET_SLIDES_ERROR, {});
                        context.commit(SET_SLIDES, data.slides);
                    })
                    .catch(({ response }) => {
                        reject(response);
                        if (response.status === 422){
                            context.commit(SET_SLIDES_ERROR, response.data.errors);
                        }
                    });
            });
        } else {
            context.commit(PURGE_AUTH);
        }
    },

    [SAVE_ABOUT](context, data) {
        if (JwtService.getToken()) {
            return new Promise((resolve, reject) => {
                ApiService.post("/home-about-save", data)
                    .then(({ data }) => {
                        resolve(data);
                    })
                    .catch(({ response }) => {
                        reject(response);
                        if (response.status === 422){
                            context.commit(SET_SLIDES_ERROR, response.data.errors);
                        }
                    });
            });
        } else {
            context.commit(PURGE_AUTH);
        }
    },

    [SAVE_SERVICE](context, data) {
        if (JwtService.getToken()) {
            return new Promise((resolve, reject) => {
                ApiService.post("/home-service-save", data)
                    .then(({ data }) => {
                        resolve(data);
                    })
                    .catch(({ response }) => {
                        reject(response);
                        if (response.status === 422){
                            context.commit(SET_SLIDES_ERROR, response.data.errors);
                        }
                    });
            });
        } else {
            context.commit(PURGE_AUTH);
        }
    },

    [SAVE_BANNER](context, data) {
        if (JwtService.getToken()) {
            return new Promise((resolve, reject) => {
                ApiService.post("/home-banner-save", data)
                    .then(({ data }) => {
                        resolve(data);
                    })
                    .catch(({ response }) => {
                        reject(response);
                        if (response.status === 422){
                            context.commit(SET_SLIDES_ERROR, response.data.errors);
                        }
                    });
            });
        } else {
            context.commit(PURGE_AUTH);
        }
    },

    [SAVE_META](context, data) {
        if (JwtService.getToken()) {
            return new Promise((resolve, reject) => {
                ApiService.post("/meta-save", data)
                    .then(({ data }) => {
                        resolve(data);
                    })
                    .catch(({ response }) => {
                        reject(response);
                        if (response.status === 422){
                            context.commit(SET_SLIDES_ERROR, response.data.errors);
                        }
                    });
            });
        } else {
            context.commit(PURGE_AUTH);
        }
    },

};

const mutations = {

    [SET_HOME_PAGE](state, data) {
        state.home = data.home;
    },

    [SET_HOME_PAGE_ERROR](state, error) {
        state.errors = error;
    },

    [SET_HOME_PAGE_LOAD](state, load) {
        state.load = load;
    },

    [SET_SLIDES](state, slides) {
        state.home.slides = slides;
    },

    [SET_SLIDES_ERROR](state, error) {
        state.errors.slide = error;
    },

};

export default {
    state,
    actions,
    mutations,
    getters
};